module.exports = __webpack_public_path__ + "static/media/fa-light-300.c3941ebc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/webfonts/fa-light-300.svg
// module id = 736
// module chunks = 0